import type { Country } from '@kitopi-com/customer-auth';

export const isLocalMode = process.env.mode === 'localhost';
export const isDevMode = process.env.mode === 'development' || isLocalMode;

export const FIREBASE_DATABASE_URL = process.env.FIREBASE_DATABASE_URL as string;

export const FIREBASE_COUNTRIES_PATH = `envs/${isDevMode ? 'dev' : 'prod'}/allowlists/wifi/allowedCountries`;

const rawFallback = process.env.FIREBASE_COUNTRIES_FALLBACK_JSON;
const parsedFallback: unknown = rawFallback ? JSON.parse(rawFallback) : [];
export const FIREBASE_COUNTRIES_FALLBACK: Country[] = Array.isArray(parsedFallback)
  ? (parsedFallback as Country[])
  : [];

export const AWS_CONFIG = {
  Auth: {
    Cognito: {
      userPoolId: process.env.COGNITO_POOL_ID!,
      userPoolClientId: process.env.COGNITO_APP_CLIENT_ID!,
      loginWith: {
        oauth: {
          domain: process.env.COGNITO_WEB_DOMAIN!,
          redirectSignIn: [process.env.COGNITO_SIGN_IN_REDIRECT_URI!],
          redirectSignOut: [process.env.COGNITO_SIGN_OUT_REDIRECT_URI!],
          responseType: 'code' as const,
          scopes: ['email', 'openid', 'profile', 'phone', 'aws.cognito.signin.user.admin'],
        },
      },
    },
  },
};

export const RECAPTCHA_KEY = process.env.RECAPTCHA_KEY;

export const API_URL = isLocalMode
  ? `${process.env.LOCAL_API}`
  : `${process.env.API_ROOT}/kitopi-wifi/`;

export const CUSTOMER_PROFILE_API_URL = `${process.env.API_ROOT}/customer-profile`;

export const ACCESS_TIME_IN_MINUTES = process.env.ACCESS_TIME_IN_MINUTES;
